import styled from 'styled-components';

const FeatureCardStyled = styled.div`
  background-repeat: no-repeat;

  .feature-card {
    &__img {
      width: calc(100% + 32px);
      max-width: 556px;
      height: auto;

      margin: -12px -16px;
    }

    &__title {
      margin-top: 12px;
    }

    &__desc {
      margin: 8px 0 25px;
    }

    &__link {
      display: flex;
      align-items: center;

      font-size: 1.8rem;
      line-height: 2.2rem;
      font-weight: 600;

      svg {
        margin-left: 11px;

        font-size: 1.9rem;
      }
    }
  }
`;

export default FeatureCardStyled;
